import { useResolvedSettings } from '../useResolvedSettings';

export function useSystemConfiguration() {
  return useResolvedSettings();
}
